import { message } from 'antd';
import { SearchType, TabKeyType, UserType } from '../types';
import { getHeader, uniqBy } from '../utils';
import {
  convertEmployeeToString,
  employeeToUid,
  getDeptPositionDesc,
  groupListItem,
  handleContactData,
  mapGroupMembersData,
  setUserTypeChange,
} from './handleData';
import Fetch from './request';
import { getUser } from './user';

const createGroupExternalByTagData = () => {
  return [
    { isShow: '1', labelEnum: 'EXTERNAL', color: 'e86e63', name: '外部' },
  ];
};

const handleDada = (item: any) => {
  // 我的组
  switch (item.type) {
    case TabKeyType.Contact:
      item.id = `${item.user_id}_${item.tenant_id}`;
      item.userId = item.user_id;
      item.desc = `${item.org_name}-${item.position_name || '暂无填写'}`;
      break;
    case TabKeyType.Groups:
      item.id = item.gid || item.groupId;
      item.name = item.name || item.groupName;
      item.desc = `${item.rosterSize ||
        item.groupUserCount ||
        item.memberCount ||
        0}人`;
      item.labelInfoList = isGroupExternal(item.kind, item.subKind)
        ? createGroupExternalByTagData()
        : [];
      // item.keyTitleHighLight = 'groupName'
      break;
    case TabKeyType.Department:
      item.id = item.deptId || item.code;
      item.name = item.deptName || item.name;
      item.desc = item.fullName || item.full_name;
      item.nodeType = Number(item.nodeType ?? item.node_type);
      //   console.log(item.nodeType, '11aaa');
      if (item.nodeType === 1) {
        item.type = TabKeyType.WorkLine;
      }
      // item.keyHighLight = 'fullName'
      // item.keyTitleHighLight = 'deptName'
      // const desc =
      // item.highlight.length === 0 ||
      // item.highlight.findIndex((a:any) => a.name === 'deptName') >= 0
      //     ? item.realFullName
      //     : 'realFullName'
      break;
    case TabKeyType.WorkLine:
      item.id = item.nodeId;
      item.name = item.name;
      break;
    default:
  }
  return {
    id: item.id,
    name: item.name,
    userId: item.user_id || '',
    avatar: item.avatar_url || item.avatar || '',
    desc: item.desc || '',
    type: item.type,
    checked: false,
    labelInfoList: item.labelInfoList || [],
    tenantId: item.tenant_id || item.tenantId,
    appId: item.app || item.appId || '',
    // highlight: item.highlight || [],
    // keyHighLight: item?.keyHighLight || '',
    // keyTitleHighLight: item?.keyTitleHighLight || ''
  };
};
// 获取最近联系人
export const getRecentlyContactList = (
  pageId: any,
  start: number,
  pageSize: number = 99,
  isSelectUser = false
) => {
  return Fetch<any>({
    api: 'joyspace.shareRecommend.getSharedRecommendList',
    method: 'GET',
    query: { page_id: pageId, start, limit: pageSize },
  })
    .then((res: any) => {
      const [data, err] = res;
      console.log(data, 'getSharedRecommendList');
      if (err) {
        if (!err['errResolved']) {
          message.error(err.msg);
        }
        return [];
      }
      if (data && !data.length) {
        return [];
      }
      const list = data.map((item: any) => {
        if (item.type === 'user') {
          item.type = TabKeyType.Contact;
          item.tenant_id = item.tenantId;
          item.name = item.name;
          item.desc = `${item.org_name}-${item.position_name || '暂无填写'}`;
        } else if (item.type === 'org') {
          item.type = TabKeyType.Department;
          // liangshan-todo
        } else if (item.type === 'workline') {
          item.type = TabKeyType.WorkLine;
        } else if (item.type === 'group') {
          item.type = TabKeyType.Groups;
        }
        return handleDada(item);
      });
      return isSelectUser
        ? list.filter((item: any) => item.type === TabKeyType.Contact)
        : list;
    })
    .catch(() => {
      return [];
    });
};
// 获取全部数据
// eslint max-params: ["error", 4]
export const getSearchGlobalAll = () => {
  // return fetch<any>(API.Search.Search(), {
  //     method: 'POST',
  //     body: JSON.stringify({
  //         page_id: pageId,
  //         search: search || '',
  //         mode: 7,
  //         scene: "share",
  //     })
  //     .catch((err:any) => {
  //         return [];
  //     });
};

// 获取部门
export const getDepartmentList = (deptId = '', displaySubDept = true) => {
  return Fetch({
    api: 'ebook.gov.getEbookDeptInfo',
    method: 'POST',
    body: { deptId, displaySubDept },
  })
    .then(async (res: any) => {
      if (res[1]) {
        if (!res[1]['errResolved']) {
          message.error(res[1].msg);
        }
        return [];
      }
      if (!res[0]) {
        return [];
      }
      let result = res[0];
      // if (!deptId && result.parentId) {
      //     try {
      //         const _res = await Fetch<any>(({
      //             api: "ebook.gov.getEbookDeptInfo", method: 'POST', body: {
      //                 deptId: result.parentId,
      //                 displaySubDept: true,
      //             }
      //         }))
      //         result = _res[0] || {}
      //     } catch (err) {
      //         result = {}
      //     }
      // }
      result.ebookSubDeptInfoList = result.ebookSubDeptInfoList || [];
      // 部门数据
      let deptInfoList = (result.ebookSubDeptInfoList || []).map(
        (item: any) => {
          item.type = TabKeyType.Department;
          const _item: any = handleDada(item);
          return _item;
        }
      );
      // 部门下的人
      const ebookInfoResList: any = handleContactData(
        result.ebookInfoResList || [],
        true
      );
      return {
        breadcrumbList: result.simpleDeptInfoList || [], // 面包屑数据
        deptInfoList: ebookInfoResList.concat(deptInfoList), // 部门
      };
    })
    .catch(err => {
      return { breadcrumbList: [], deptInfoList: [] };
    });
};

// 获取虚拟通讯录
export const getWorkLineList = (depId = '', version = 0, isInit = false) => {
  return Fetch({
    api: 'ebook.gov.getWorkLineEbook',
    method: 'POST',
    body: { nodeId: depId, version },
  })
    .then(async (res: any) => {
      const [data, err] = res;
      if (err) {
        if (!err['errResolved']) {
          message.error(err.msg);
        }
        return {};
      }
      const { ebook } = data;
      if (!depId && !isInit && ebook?.parentNodeList.length === 1) {
        ebook.subNodeList = ebook.parentNodeList;
        ebook.parentNodeList = [];
        ebook.emplList = [];
      }
      // 面包屑
      const simpleDeptInfoList = [
        {
          deptId: '-1',
          deptName: '虚拟通讯录',
        },
      ];
      ebook?.parentNodeList.map((item: any) => {
        simpleDeptInfoList.push({
          deptId: item.nodeId,
          deptName: item.name,
        });
      });
      // 部门数据
      let deptInfoList = (ebook.subNodeList || []).map((item: any) => {
        item.type = TabKeyType.WorkLine;
        const _item: any = handleDada(item);
        return _item;
      });
      // 部门下的人
      const ebookInfoResList: any = handleContactData(
        ebook.emplList || [],
        true
      );
      return {
        breadcrumbList: simpleDeptInfoList || [], // 面包屑数据
        deptInfoList: ebookInfoResList.concat(deptInfoList), // 部门
      };
    })
    .catch(err => {
      return { breadcrumbList: [], deptInfoList: [] };
    });
};

// 获取群组
export const getGroupList = async () => {
  const res = await Fetch<any>({
    api: 'elabel.getLabels',
    method: 'POST',
    body: { labelType: '1' },
  });
  if (res[1]) {
    // @ts-ignore
    if (!res[1]['errResolved']) {
      message.error(res[1].msg);
    }
    return [];
  }
  if (!res[0]) {
    return [];
  }
  const { labels, labelType } = res[0];
  const res2: any = await Fetch({
    api: 'egroup.getGroupsByLabel',
    method: 'POST',
    body: { labelId: labels[0].labelId },
  });
  if (res2[1]) {
    if (!res2[1]['errResolved']) {
      message.error(res2[1].msg);
    }
    return [];
  }
  if (!res2[0]) {
    return [];
  }
  const { labelId, groups = [] } = res2[0];
  const groupIds =
    groups?.map((item: any) => {
      return { groupId: item.gid };
    }) || [];
  if (!groupIds.length) {
    return [];
  }
  const res3 = await Fetch<any>({
    api: 'egroup.groupGetInfo',
    method: 'POST',
    body: { type: 5, groupIds },
  });
  if (res3[1]) {
    // @ts-ignore
    if (!res3[1]['errResolved']) {
      message.error(res3[1].msg);
    }
    return [];
  }
  if (res3[0]) {
    const { groups } = res3[0];
    const result = groups?.filter(
      (item: any) => !isCrossPlatformGroup(item.kind, item.subKind)
    );
    return result?.map((item: any) => {
      item.type = TabKeyType.Groups;
      return handleDada(item);
    });
  }
  return [];
};

export enum GroupRosterIdentity {
  'ordinary',
  'sub_administrator',
  'administrator',
}
// 获取我的联系人
export const getContactUserList = async () => {
  const res: any = await Fetch<any>({
    api: 'efriend.getFriendsByGroup',
    method: 'POST',
    body: {},
  });
  if (res[1]) {
    if (!res[1]['errResolved']) {
      message.error(res[1].msg);
    }
    return [];
  }
  if (!res[0]) {
    return [];
  }
  const { groups } = res[0];
  let friends = [];
  for (let item of groups) {
    for (let _item of item.friends) {
      friends.push({
        appId: _item.app,
        isMulti: false,
        teamId: _item.teamId,
        userId: _item.pin,
      });
    }
  }
  if (!friends.length) {
    return [];
  }
  const result = await Fetch<any>({
    api: 'ebook.gov.getUserEbookDetailList',
    method: 'POST',
    body: { ebookUserDetailReqList: friends },
  });
  if (result[1]) {
    // @ts-ignore
    if (!result[1]['errResolved']) {
      message.error(result[1].msg);
    }
    return [];
  }
  if (!result[0]) {
    return [];
  }
  const user = await getUser();
  const userList = mapGroupMembersData(result[0], user).filter(
    (item: any) => item.userType !== UserType.CrossPlatform
  );
  if (!userList?.length) {
    return [];
  }
  const data = handleContactData(userList);
  const newList = groupListItem(data);
  return newList;
};

export const getSearchGlobal = async (
  keyword = '',
  searchType: SearchType,
  pageNo = 1,
  pageSize = 10
) => {
  const { appId, appKey } = getHeader();
  if (!keyword) {
    return [];
  }
  // 参数
  const res = await Fetch<any>({
    api: 'search.searchGlobal',
    method: 'POST',
    body: {
      appId,
      appKey,
      indexName: 'global',
      keyword,
      searchType,
      pageNo,
      pageSize,
    },
  });
  if (res[1]) {
    // @ts-ignore
    if (!res[1]['errResolved']) {
      message.error(res[1].msg);
    }
    return [];
  }
  if (!res[0]) {
    return [];
  }
  const {
    contacts,
    depts,
    groups,
    hasMoreGroups,
    hasMoreDepts,
    hasMoreContacts,
  } = res[0];
  let users = [],
    groupsArr: any[] = [],
    _depts = [];
  if (contacts?.length > 0) {
    const user = await getUser();
    const userList = contacts
      .map((item: any) => {
        const userType = setUserTypeChange(item, {
          app: user.app_id,
          teamId: user.tenant_id,
        });
        const desc = getDeptPositionDesc({
          unitName: item?.unitName || '',
          deptName: item?.deptName || '',
          titleName: item?.titleName || '',
          userType,
        });
        const descHighLight = keyword
          ? [{ key: keyword, name: 'desc', value: desc }]
          : [];
        return {
          ...item,
          desc,
          userType,
          descHighLight,
        };
      })
      .filter((item: any) => item.userType !== UserType.CrossPlatform);
    users = handleContactData(userList);
    if (users.length !== 0) {
      users[0].typeName = '联系人';
      users[users?.length - 1].hasMore = hasMoreContacts;
    }
  }
  if (depts?.code === '0' && depts?.data?.length > 0) {
    _depts = (depts?.data || []).map((item: any, index: number) => {
      item.type = TabKeyType.Department;
      const _item: any = handleDada(item);
      _item.keyTitleHighLight = 'deptName';
      _item.keyHighLight = 'realFullName';
      const filterHighlight: any =
        item.highlight.length > 0
          ? item.highlight.map((item: any) => {
              if (item.name === 'fullName') {
                return {
                  ...item,
                  name: 'realFullName',
                  key: item.key.split(',')[0] || item.key,
                };
              }
              return item;
            })
          : item.realFullName;
      _item.highlight = item.highlight;
      _item.descHighLight = filterHighlight;
      _item.desc = item.realFullName;
      return _item;
    });
    if (_depts.length !== 0) {
      _depts[0].typeName = '部门';
      _depts[_depts?.length - 1].hasMore = hasMoreDepts;
    }
  }
  if (groups?.length > 0) {
    for (let item of groups) {
      const { kind, subKind } = item as any;
      (item as any).type = TabKeyType.Groups;
      if (!isCrossPlatformGroup(kind, subKind)) {
        const newItem: any = handleDada(item);
        newItem.keyTitleHighLight = 'groupName';
        newItem.highlight = item.highlight;
        groupsArr.push(newItem);
      }
    }
    if (groupsArr.length !== 0) {
      (groupsArr[0] as any).typeName = '我的组';
      (groupsArr[groupsArr?.length - 1] as any).hasMore = hasMoreGroups;
    }
  }
  return {
    data: [].concat(users, groupsArr as any, _depts),
    hasMoreContacts,
    hasMoreDepts,
    hasMoreGroups,
  };
};

/**
 * 判断是不是外部群 app一样  teamId不一样
 */
export function isExternalGroup(kind: number, subKind: number): boolean {
  return kind === 1024 && subKind === 6;
}

/**
 * 判断是不是跨平台群会话 app不一样
 */
export function isCrossPlatformGroup(kind: number, subKind: number): boolean {
  return kind === 1024 && subKind === 3;
}

export function isGroupExternal(kind: number, subKind: number): boolean {
  // return isCrossPlatformGroup(kind, subKind) || isExternalGroup(kind, subKind);
  return false;
}
